import defaultRestApi from "../common/RestApiInstance";
import APIS from "../common/APIs";
import querystring from 'query-string';
import axios from 'axios';


export default class BetServices {

    static postPlaceBetAPI = (selectionsData, uniqueRequestId) => {
        return defaultRestApi.post(APIS.betPlacementBuyURL(uniqueRequestId),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static getOddsSelectionsInfo = (selectionsData) => {
        return defaultRestApi.post(APIS.oddsSelectionsURL(),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static updateOddsSelectionsInfo = (selectionsData) => {
        return defaultRestApi.post(APIS.oddsSelectionsUpdateURL(),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static getAllOddsSelectionsInfo = (selectionsData) => {
        return defaultRestApi.post(APIS.allOddsSelectionsURL(),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static updateAllOddsSelectionsInfo = (selectionsData) => {
        return defaultRestApi.post(APIS.allOddsSelectionsUpdateURL(),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static placeTeaserBetAPI = (selectionsData, uniqueRequestId) => {
      return defaultRestApi.post(APIS.buyTeaserBetURL(uniqueRequestId),
        selectionsData
        , {
          headers: {
            "Content-Type": "application/json"
          }
        })
    }

    static placeParlayBet = (selections, uniqueRequestId) =>{
        return defaultRestApi.post(APIS.placeParlayBetURL(uniqueRequestId), 
            selections, {
                headers: {
                  "Content-Type": "application/json"
                }
            });
    }

    static parlayRemoveSelection = (selectionsData, legId) =>{
        return defaultRestApi.post(APIS.parlayRemoveSelectionsURL(legId), 
            selectionsData, {
                headers: {
                  "Content-Type": "application/json"
                }
            });
    }

    static parlayOddsSelections = (selectionsData) => {
        return defaultRestApi.post(APIS.parlayOddsSelectionsURL(),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static parlayUpdateOdds = (selectionsData) => {
        return defaultRestApi.post(APIS.parlayUpdateOddsURL(),
            selectionsData
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

    static updatePitcherParlay = (params) => {
        return defaultRestApi.get(APIS.updatePitcherParlayURL(params));
    }

    static getMyBets = () => {
      return defaultRestApi.get(APIS.mybetURL());
    }

    static postPlaceParlayBetAPI = (payload, uniqueRequestId) => {
      return defaultRestApi.post(APIS.placeParlayBetURL(uniqueRequestId),
        payload
        , {
          headers: {
            "Content-Type": "application/json"
          }
        })
    }

    static updateParlayTicket = (params) => {
      return defaultRestApi.get(APIS.updateParlayTicketURL(querystring.stringify(params)))
    }

    static getTeaserOddsSelection = (params) => {
      return defaultRestApi.get(APIS.getTeaserTicketURL(params));
    }
    
    static removeTeaserTicket = (params) => {
      return defaultRestApi.get(APIS.removeTeaserTicketURL(params));
    }

    static removeTeaserTicket = (params) => {
      return defaultRestApi.get(APIS.removeTeaserTicketURL(params));
    }

    static buyTeaserBetURL = (payload, uniqueRequestId) => {
        return defaultRestApi.post(APIS.buyTeaserBetURL(uniqueRequestId),
            payload
            , {
                headers: {
                    "Content-Type": "application/json"
                }
            })
    }

  static submitRbPlaceBetsSameDomain = (data, token) => {
    return defaultRestApi.post(APIS.getHrPlaceBetsUrl(),
      data
      , {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      })
  }

  static submitHorseRacingPlaceBetsConfig = (hrDomainName, data, token) => axios.create({
    baseURL: '/'
  }).post(`${hrDomainName}${APIS.getHrPlaceBetsUrl()}`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }
    });

    static getLimitBet = (data) => defaultRestApi.post(APIS.getLimitBetUrl(),
        data,
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token-user') || ''}`
            }
        });
}


// WEBPACK FOOTER //
// ./src/app/services/BetServices.js